module.exports = __webpack_public_path__ + "static/media/img9.3ffba4ff.png";